import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pa } from '../classes/pa';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class PaService {
    API_PA_URL = config.serverAddress + ':' + config.serverPort + '/pa/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_PA_URL + 'all');
    }
    getByID(id: string) {
        return this.http.get(this.API_PA_URL + id);
    }
    create(pa: Pa) {
        return this.http.post(this.API_PA_URL + 'create', pa);
    }
    upsert(pa: Pa) {
        return this.http.post(this.API_PA_URL + 'upsert', pa);
    }
    update(pa: Pa) {
        return this.http.put(this.API_PA_URL + 'update', pa);
    }
    delete(id: number) {
        return this.http.delete(this.API_PA_URL + 'delete/' + id);
    }
}